import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

export const getEditorDirectionsColumns = (
  t: TFunction,
  options: string[],
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`directions.${option}`),
      dataIndex: option,
      key: option,
    };

    // Special render for status field
    if (option === "status") {
      return {
        ...baseColumn,
        render: (value: string) => <span>{t(`directions.${value}`)}</span>,
      };
    }

    // Default render
    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
